<template>
  <div class='product-ingredient-save--container'>

    <el-drawer :visible.sync='show' :close-on-press-escape='false' :title="`编辑产品成分`"
               append-to-body
               custom-class='product-ingredient-save-drawer'>
      <el-form ref='form' :model='form' :rules='rules' label-width='80px' size='medium'>
        <el-form-item label='条码' prop='barcode'>
          <el-input v-model='form.barcode' placeholder='请输入条码'/>
        </el-form-item>
        <el-form-item label='产品成分' :key='key_upload' class='form-item-image__outer form-item-all-line'>
          <ml-upload-images ref='images' enable-crop :images-param='form.ingredient_images' class='form-item-image'>
            <p class='placeholder'>成分图片</p>
            <div class='image-upload-btn'>
              <div class='upload-content'>
                <i class='el-icon-upload'/>
                <p class='upload-text'>添加上传图片</p>
              </div>
            </div>
          </ml-upload-images>
        </el-form-item>
      </el-form>
      <div style='height: 80px;'/>
      <div class='footer'>
        <ml-button size='medium' @click.native='handleSubmit'/>
      </div>
    </el-drawer>
  </div>
</template>
<script>

import MlInput from '../../../components/MlInput/index.vue'
import MlButton from '../../../components/MlButton/index.vue'
import PageHeaderLayout from '../../../layouts/PageHeaderLayout.vue'
import MlUploadImages from '../../../components/MlUploadImg/multiple.vue'

const rules = {
  product_id: [{required: true, message: '请选择产品', trigger: 'change'}]
}
const ModelForm = {
  product_id: null,
  barcode: null,
  ingredient_images: []
}
const getKey = function () {
  return '' + (new Date().getTime())
}
export default {
  name: 'ProductIngredientsEdit',
  components: {
    MlUploadImages,
    PageHeaderLayout,
    MlButton,
    MlInput
  },
  data() {
    return {
      rules,
      key: getKey(),
      key_upload: getKey(),
      loading: false,
      show: false,
      form: {...{}, ...ModelForm},
    }
  },
  methods: {
    getKey,
    /**
     * 编辑
     * 给父组件用
     * @param obj
     */
    interfaceEdit: function (obj) {
      this.handleShowDrawer(obj)
    },
    /**
     * 弹出层
     * @param edit_obj
     */
    handleShowDrawer: async function (edit_obj = false) {
      // 重置表单
      this.form = {...{}, ...ModelForm}
      if (typeof edit_obj === 'object') {
        const ingredient_images = []
        if (Array.isArray(edit_obj.ingredient_images)) {
          edit_obj.ingredient_images.forEach((image, index) => {
            if (image) {
              const obj = {src: image, id: index}
              ingredient_images.push(obj)
            }
          })
          this.form.ingredient_images = ingredient_images
          this.form.barcode = edit_obj.barcode
        }
      }
      this.show = true
      this.key_upload = 'key_upload' + getKey()
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
      // console.log(this.form)
    },
    handleCloseDrawer: function () {
      this.show = false
    },
    handleSubmit: async function () {
      this.$refs.form.validate(async (val) => {
        if (val) {
          const params = this.form
          const ingredient_images = []
          if (this.$refs.images) {
            this.$refs.images.images.forEach(image => {
              if (image.src) {
                ingredient_images.push(image.src)
              }
            })
          }

          params.ingredient_images = ingredient_images
          const postData = {
            ingredient_images: ingredient_images,
            ingredient_barcode: params.ingredient_barcode,
            barcode: params.barcode
          }
          this.$emit('handleSubmit', postData)
        }
      })
    }
  }
}
</script>

<style lang='scss'>
.product-ingredient-save--container {
  display: inline;
}

.product-ingredient-save-drawer {
  width: 1000px !important;

  .el-drawer__title {
    border-top-left-radius: 10px !important;
  }

  .el-drawer__header {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 700;
    text-align: center;
  }

  .el-drawer__body {
    border-bottom-left-radius: 10px !important;
    padding: 0 20px;
  }
  .el-form {
    display: grid;
    //grid-template-columns: repeat(2, calc(50% - 10px));
    grid-template-columns: repeat(1, 100%);
    grid-column-gap: 20px;

    .el-radio-group {
      width: 100%;

      .el-radio-button {
        width: 50%;

        span {
          width: 100%;
        }
      }
    }
  }

  .ml-upload-image {
    position: relative;
    width: 140px;
    height: 205px;

    &__outer {
      .el-form-item__content {
        display: flex;
      }
    }

    .placeholder {
      position: absolute;
      width: 100%;
      top: -14px;
      text-align: center;
      line-height: 18px;
      display: block;
      opacity: 1;
      border-radius: 6px 6px 0 0;
      background-color: #ff5a91;
      padding: 4px 0;
      color: #fff;
    }

    .image-upload-btn {
      border: 1px dashed #d7dbe0;
      border-radius: 9px;
      background-color: #f7f8fa;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .upload-content {
      width: 100%;
      cursor: pointer;
      position: absolute;
      transform: translateY(-18px);
      text-align: center;

      i {
        font-size: 50px;
        color: #ccc;
      }
    }

    .upload-text {
      font-size: 12px;
      line-height: 1;
      color: #666;
      text-align: center;
      margin: 12px 0 0;
    }
  }

  .el-select, .el-date-editor, .el-input, .el-autocomplete {
    width: 100%;
  }

  .select-category {
    width: calc(100% - 46px);
    margin-right: 10px;
  }
}
</style>
